import { useState } from "react"
import ErrorMessage from "@/v2-ui/ErrorMessage"
import Dialog from "@/v2-ui/dialog"
import Button, { TooltipButton } from "@/v2-backoffice-client/components/button"
import { useUserUpdateMfaPhoneMutation } from "@/v2-backoffice-client/user/mfa/user.mfa.updatePhone.mutation"
import UserMfaPhoneForm from "@/v2-backoffice-client/user/mfa/UserMfaPhoneForm"

export type UserMfaEditPhoneProps = {
  userId: number
  methodId: string
  currentPhoneNumber: string
  onCompleted?(): void
}

// Overrides the phone number on an existing registered method — the fix for a
// user locked out because a shared-account holder registered the wrong number.
function UserMfaEditPhone(props: UserMfaEditPhoneProps) {
  const { userId, methodId, currentPhoneNumber, onCompleted } = props

  const [open, setOpen] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState(currentPhoneNumber)

  const [updatePhone, { loading, error }] = useUserUpdateMfaPhoneMutation({
    onCompleted() {
      setOpen(false)
      onCompleted?.()
    },
  })

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="sm"
        content="Change the number on this MFA method, e.g. when the wrong one was registered."
        onClick={() => {
          setPhoneNumber(currentPhoneNumber)
          setOpen(true)
        }}
        iconSrc="pencil"
      >
        Edit
      </TooltipButton>

      <Dialog open={open} onOpenChange={setOpen}>
        <Dialog.Content align="top">
          <Dialog.Header>
            <Dialog.Title>Edit phone number</Dialog.Title>
          </Dialog.Header>

          <ErrorMessage className="my-4 text-center" error={error} />

          <UserMfaPhoneForm
            formId="user-mfa-edit-phone-form"
            value={phoneNumber}
            onValueChange={setPhoneNumber}
            onSubmit={() => {
              updatePhone({
                variables: { id: userId, methodId, phoneNumber },
              })
            }}
          />

          <Dialog.Footer>
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                setOpen(false)
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              isLoading={loading}
              form="user-mfa-edit-phone-form"
            >
              Save
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog>
    </>
  )
}

export default UserMfaEditPhone
